import { Link } from "react-router-dom";

const Button = ({
  text,
  className = "",
  onClick,
  disabled = false,
  icon,
  iconPosition = "left",
  to,
  href,
  children,
  ...props
}) => {
  const content = (
    <>
      {icon && iconPosition === "left" && <span className="me-2">{icon}</span>}
      {text || children}
      {icon && iconPosition === "right" && <span className="ms-2">{icon}</span>}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={className} onClick={onClick} {...props}>
        {content}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={className} onClick={onClick} {...props}>
        {content}
      </a>
    );
  }

  return (
    <button
      className={className}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {content}
    </button>
  );
};

export default Button;

